import React, {Component} from "react"

import AppContainer from "@irati/ui/src/AppContainer"
import {LangLoader} from "@irati/utils/lang"
import {NestedRoute, withPartialRoute} from "@irati/utils/history/routing"
import {PERKS} from "@irati-web/app/src/routeConfig"

import PlatformHomepage from "../containers/PlatformHomepage"

class HomeRoutes extends Component {
  render() {
    return (
      <LangLoader bucket={PERKS}>
        <AppContainer>
          <NestedRoute exact path="/home" component={PlatformHomepage} useGrid={false} />
        </AppContainer>
      </LangLoader>
    )
  }
}

export default withPartialRoute(HomeRoutes)
